export const LinedinIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.849609 2.81556C0.849609 2.23835 1.05232 1.76216 1.45772 1.38699C1.86312 1.0118 2.39016 0.824219 3.0388 0.824219C3.67587 0.824219 4.1913 1.00891 4.58513 1.37833C4.99053 1.75928 5.19324 2.25566 5.19324 2.86751C5.19324 3.42162 4.99633 3.88337 4.6025 4.25279C4.19711 4.63374 3.66428 4.82422 3.00405 4.82422H2.98668C2.3496 4.82422 1.83417 4.63374 1.44034 4.25279C1.04651 3.87184 0.849609 3.39275 0.849609 2.81556ZM1.07548 17.9671V6.39997H4.93262V17.9671H1.07548ZM7.06969 17.9671H10.9268V11.5082C10.9268 11.1041 10.9732 10.7925 11.0658 10.5731C11.228 10.1806 11.4741 9.84873 11.8042 9.57746C12.1344 9.30617 12.5484 9.17054 13.0465 9.17054C14.3438 9.17054 14.9925 10.0421 14.9925 11.7853V17.9671H18.8496V11.335C18.8496 9.62652 18.4442 8.33071 17.6334 7.44759C16.8226 6.56448 15.7512 6.12292 14.4191 6.12292C12.9249 6.12292 11.7608 6.76361 10.9268 8.04499V8.07963H10.9095L10.9268 8.04499V6.39997H7.06969C7.09285 6.76938 7.10444 7.918 7.10444 9.84586C7.10444 11.7737 7.09285 14.4808 7.06969 17.9671Z"
        fill="white"
      />
    </svg>
  );
};
